/** @module csi/canvas/ImageReview */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/action/ActionView",
	"csi/action/Controller",
	"csi/action/ProxyController",
	"csi/comm/PostRequest",
	"csi/def/Action",
	"csi/def/View",
	"csi/def/ViewRef",
	"csi/widget/_svg/util",
	"csi/xml"
], function(declare, lang, ActionView, Controller, ProxyController, PostRequest, Action, View, ViewRef, svgUtil, xml) {

	const ACTION_UPDATE_ACCEPT = "ImageUpdateAccept";
	const ACTION_UPDATE_DENY = "ImageUpdateDeny";

	const _AcceptController = declare([ProxyController], {

		/**
		 * @override
		 * Accept changes when clicking accept
		 */
		process: function() {
			const acOrig = this.getOriginalController();
			acOrig.bUpdate = this.getAction()._acceptChanges;
			this.inherited(arguments);
		}
	});

	const _ImageReviewController = declare([Controller], {
		bShowWait: true, // show loading screen

		/**
		 * @override
		 * Add Accept and Deny buttons
		 */
		addProxyActions: function(defView, defActions) {

			defActions.addAction(this.getProxyAction(ACTION_UPDATE_DENY, false, {
				classController: _AcceptController,
				_acceptChanges: false
			}));

			defActions.addAction(this.getProxyAction(ACTION_UPDATE_ACCEPT, false, {
				classController: _AcceptController,
				m_bSubmit: true,
				_acceptChanges: true
			}));
			this.inherited(arguments);
		},

		/**
		 * @override
		 * Get the view for the add attribute placeholder dialog
		 */
		getActionView: function(vr) {
			const defView = lang.mixin(new View(), {
				classController: "csi/canvas/ImageReviewWidget",
				m_id: "ImageReviewWidget",
				m_typeView: "Html",
			});

			return new ActionView(this, defView, this.getNode());
		},

		/**
		* @override
		* Refresh widget then either update or unlink placeholders
		*/
		postProcessSuccess: function() {
			const {bUpdate, widget} = this;
			// Don't need to check placeholders again here
			widget.blockPlaceholderCheck = true;
			widget.refreshWidget().then(() => {
				const {canvasWidgetNode} = widget;
				// In the case where we reject updates, we unlink all placeholders on the page.
				if (!bUpdate) {
					widget.unlinkAllAttributePlaceholders();
					canvasWidgetNode.updateToolbar();
				} else {
					// Accept updates to placeholders. This action should update the attribute values.
					// For attributes deleted from the system, delete the attribute from the placeholder.
					canvasWidgetNode.updateAllAttributePlaceholders();
				}
			});
		},

		/**
		 * @override
		 * Add call to SiteAdmin CanvasUpdateImages
		 */
		toWriter: function() {
			const node = this.getNode();
			const nodeType = node.$Type;
			if (nodeType !== "CanvasTemplate") {
				const nodeUrl = (svgUtil.isNonRevisionCanvas(node)) ? this.getNodeURL() : this.getParentURL();
				this.m_writer.callMethod("SiteAdmin", "CanvasUpdateImages")
					.addParameter("URL", xml.ATTR_CNL, nodeUrl)
					.addParameter("Update", xml.ATTR_BOOLEAN, this.bUpdate);
			}
		}

	});

	return declare(Action, {
		m_id: "ImageReview",
		classController: _ImageReviewController,
	});
});
